import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';



export const autherizationInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Only attach the token to admin API calls
  if (req.url.startsWith('/api/') && authService.isLoggedIn) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authService.accessToken}`
      }
    });
    return next(cloned);
  }

  return next(req);
};
